import { WorkflowTimeline } from '../../../../components/WorkflowStages/WorkflowTimeline';
import { useSelectedWorkflow } from './useSelectedWorkflow';

/**
 * Visual summary of the selected workflow's approval pipeline, rendered directly under the Approval
 * Workflow picker. Re-mounts (via the workflow id passed to `animationKey`) whenever the selected
 * workflow changes, so the stagger animation replays on every selection. On the edit form the workflow
 * is already selected, so the indicator is present immediately.
 */
export function WorkflowStagesIndicator() {
  const { selectedWorkflow, stages } = useSelectedWorkflow();

  if (!selectedWorkflow) {
    return null;
  }

  return (
    <div style={{ marginTop: 12 }}>
      <WorkflowTimeline
        stages={stages}
        animationKey={selectedWorkflow.id}
        labels={selectedWorkflow.stageLabels}
      />
    </div>
  );
}
